import { atom, useAtomValue } from 'jotai';

export const currentClass = atom<Knowledge.SingleClass.Value | null>(null);

export const currentClassId = atom((get) => {
  const cc = get(currentClass);
  return cc?.id ? String(cc.id) : '';
});

export const currentKcList = atom<Knowledge.SingleClass.Knowledge[]>([]);

export const currentSpuList = atom<ItemSelectV2.Item[]>([]);

export const useCurrentSpuList = () => {
  return useAtomValue(currentSpuList);
};

export const allStoreList = atom<Record<string, any>>([]);
